import React, { useState, useEffect } from 'react'
import AceEditor from 'react-ace'
import { ContextToolbar } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { PanelPermissions } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { TabsPanelWithLock } from '../../components/tab-panel-with-lock'
import { AuditLogTab } from '../../common/auditlog'

function MenuEditor(props) {
  const Ctx = useTraversal()
  const [fetching, setFetching] = useState(true)
  const [menu, setMenu] = useState(null)

  const canModifyContent = Ctx.hasPerm('guillotina.ModifyContent')

  useEffect(() => {
    async function load() {
      setFetching(true)
      const r = await Ctx.client.rest.get(Ctx.path)
      const data = await r.json()
      const keys = ['html']
      setMenu(keys.reduce((acc, k) => ({ ...acc, [k]: data[k] }), {}))
      setFetching(false)
    }
    load()
  }, [Ctx.path])

  async function save(ev) {
    ev.preventDefault()

    const r = await Ctx.client.upsert(Ctx.path, {
      '@type': 'Menu',
      ...menu,
    })

    if (r.status >= 200 && r.status < 300)
      Ctx.flash('Guardado satisfactoriamente', 'success')
    else {
      const resp = await r.json()
      const error =
        resp.type === 'DeserializationError'
          ? JSON.stringify(resp.deserialization_errors)
          : resp
      Ctx.flash('Error al gaurdar:\n' + JSON.stringify(error), 'danger', 15)
    }
  }

  if (fetching) return <Loading />

  return (
    <form onSubmit={save}>
      <AceEditor
        mode="html"
        theme="textmate"
        value={menu.html}
        onChange={(html) => setMenu({ ...menu, html })}
        width="100%"
        name="HTML_editor"
        fontFamily="Menlo, Consolas, Ubuntu Mono"
        editorProps={{
          $blockScrolling: Infinity,
        }}
      />

      <button
        className="button is-primary"
        type="submit"
        style={{ marginTop: 10 }}
        disabled={!canModifyContent}
      >
        Guardar
      </button>
    </form>
  )
}

const tabs = {
  Edit: MenuEditor,
  Permissions: PanelPermissions,
  AuditLog: AuditLogTab,
}

const tabsPermissions = {
  Edit: 'guillotina.ModifyContent',
  Permissions: 'guillotina.SeePermissions',
  AuditLog: 'vinissimus.ViewLogs',
}

export function MenuView(props) {
  const ctx = useTraversal()
  const calculated = ctx.filterTabs(tabs, tabsPermissions)
  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Edit"
      editableTabs={['Edit']}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
